import { CookieOffIcon } from './CookieOffIcon';

/**
 * author: Colton Wiscombe
 * id 9B401BB3-9510-457F-9C35-BAC5A30BF91F
 * name cookie-off
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-off.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitOffIcon = CookieOffIcon;
export default BiscuitOffIcon